export default {
	mounted: function() {
		analytics.page({type: 'page', name: 'FAQs', path: 'FAQs'}, {integrations: {'AdWords': false}});
	},
	methods: {
		scrollTo: function(id) {
			let ele = document.getElementById(id);
			let position = ele.offsetTop;

			window.scroll({
			  top: position, 
			  left: 0, 
			  behavior: 'smooth' 
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/FAQ/faq.js